import React from "react";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { isTechnician } from "../pages/Authentication/userMetaData";

const RedirectBasedOnRole = ({ user }) => {
  console.log("RedirectBasedOnRole user", user);

  const isTech = isTechnician(user);
  console.log("RedirectBasedOnRole", isTech);

  if (isTech) {
    return <Redirect to={`/cms-chargers`} />;
  } else {
    return <Redirect to={`/dashboard`} />;
  }
};

const mapStateToProps = (state) => ({
  user: state.Login.user,
});

export default connect(mapStateToProps)(RedirectBasedOnRole);
